module.exports = __webpack_public_path__ + "media/images/magenta_sport_logo-e03df3d679e8a676f406c6f7656c7c93.svg";